/**
 * Deduplicated, trimmed ad set ids from guided-edit PUT `target_adset_ids`
 * (same normalization in API handler and dashboard client).
 */
export function normalizeGuidedEditTargetAdsetIds(
  raw: readonly (string | undefined | null)[] | undefined
): string[] {
  return Array.from(
    new Set(
      (raw ?? [])
        .map((id) => id?.trim())
        .filter((id): id is string => Boolean(id))
    )
  );
}
